const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/custom-item-status/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { getItemStatusesQueryOptions } from '@/lib/queries/common/useGetItemStatusesQuery';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/custom-item-status/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getItemStatusesQueryOptions({
      includeArchived: true
    }));
    return {
      crumb: i18n.t($ => $.customItemStatus.heading)
    };
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.customItemStatus.heading)
    }
  }
});